import { NgModule } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';
import { FooterComponent } from './footer/footer.component';

import { SharedModule } from '../shared/shared.module';
import { ToasterUtilService } from '../util/toaster-util.service';
import { ToasterService, ToasterModule } from 'angular2-toaster';
import { ToasterModalUtilService } from '../util/toaster-modal-util.service';
import { TranslateService } from '@ngx-translate/core';
import { AlterarSenhaComponent } from '../shared/componentes/alterar-senha/alterar-senha.component';

@NgModule({
    imports: [
        SharedModule,
        ToasterModule
    ],
    providers: [
        UserblockService,
        TranslateService,
        ToasterService,
        ToasterUtilService,
        ToasterModalUtilService
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        FooterComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        FooterComponent
    ],
    entryComponents: [
      AlterarSenhaComponent
    ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// ./src/app/layout/layout.module.ts